import { defineMessages } from 'react-intl';

export const scope = 'app.components.GroupStageHandler';

export const messages = defineMessages({
  noAthletes: {
    id: `${scope}.noAthletes`,
    defaultMessage: 'No {athletes} available to group — everyone in this age group is concluded or held. {reviewLink}',
  },
  reviewLink: {
    id: `${scope}.reviewLink`,
    defaultMessage: 'Review them here',
  },
});
